import React from 'react';
import { Reveal } from './Reveal';
import { audiences } from '../data/hero';
export function ProfessionalAudience() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-200" data-mp="3oiwj1r2o7fzq">
      <Reveal className="mx-auto max-w-5xl text-center" data-id="element-201" data-mp="3tgodarqsfe73">
        <h2 className="font-serif text-4xl leading-tight text-navy sm:text-5xl" data-id="element-202" data-mp="3tf3hyzwnfr86">
          🧬 Progettato per le persone pronte a <span className="text-sage" data-id="element-203" data-mp="71lsobliyz2f">spezzare il ciclo</span>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-slate sm:text-lg" data-id="element-204" data-mp="71c32p4e6tx9">
          Se porti schemi che non hai scelto, un dolore che non hai creato, e una storia che non è mai stata veramente
          tua — questo sistema è stato costruito per te.
        </p>
        <ul className="mt-10 flex flex-wrap justify-center gap-3" data-id="element-205" data-mp="l0uw0aomtyoz">
          {audiences.map(audience => <li key={audience} className="rounded-full border border-amber/50 bg-surface px-4 py-2.5 text-sm font-semibold text-navy shadow-premium" data-id="element-206" data-mp="2hvhl8dipjd05">
              ✅ {audience}
            </li>)}
        </ul>
      </Reveal>
    </section>;
}